import { render, staticRenderFns } from "./UcRentalServices.yaml?vue&type=template&id=461ff674&component"
import script from "./UcRentalServices.yaml?vue&type=script&lang=ts&component"
export * from "./UcRentalServices.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports